export { ResourceLinkCard } from './resource-link-card';
